import { RESET_STATE } from 'store/global/actions';

import { POS_CONFIGURATIONS_ACTION_TYPE } from '../actions';

const initialState = {
  list: [],
};

const posConfigurationsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case POS_CONFIGURATIONS_ACTION_TYPE.GET_LIST:
      return { ...state, list: Array.isArray(payload) ? payload : [] };

    case POS_CONFIGURATIONS_ACTION_TYPE.CREATE:
      return { ...state, list: [...state.list, payload] };

    case POS_CONFIGURATIONS_ACTION_TYPE.UPDATE:
      return {
        ...state,
        list: state.list.map(config =>
          config.posConfigurationId === payload.posConfigurationId ? payload : config,
        ),
      };

    case POS_CONFIGURATIONS_ACTION_TYPE.DELETE:
      return {
        ...state,
        list: state.list.filter(config => config.posConfigurationId !== payload.id),
      };

    case POS_CONFIGURATIONS_ACTION_TYPE.SET_DEFAULT:
      return {
        ...state,
        list: state.list.map(config => ({
          ...config,
          isDefault: config.posConfigurationId === payload.id,
        })),
      };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default posConfigurationsReducer;
